export const modelSolution = 'model-solution';
